import { ROUTES } from 'configs/routes';
import { NotificationEntity, NotificationType } from 'entities/Notification';

type NotificationLinkConfig = {
  label: string;
  to: (notification: NotificationEntity) => string;
};

const getLeadExpLink = (notification: NotificationEntity): string => {
  if (notification.type !== 'LEAD_EXP') {
    return ROUTES.lk.leads.create();
  }

  return ROUTES.lk.leads.detail.create(notification.extra.leadId);
};

export const notificationLinkConfigMap: Partial<Record<NotificationType, NotificationLinkConfig>> = {
  LEAD_EXP: {
    label: 'К заявке',
    to: getLeadExpLink,
  },
  // TODO: вернуть, когда бэкенд добавит ACCREDITATION_STAGE_CHANGED в NoticeType
  // ACCREDITATION_STAGE_CHANGED: {
  //   label: 'К профилю компании',
  //   to: ROUTES.lk.profile.create,
  // },
};
